import React from "react";
import { Navigate } from "react-router-dom";
import {
  getSuperAdminToken,
  isSuperAdminTokenValid,
} from "../../api/superadminClient";

export default function SuperAdminRoute({ children }) {
  const token = getSuperAdminToken();
  if (!isSuperAdminTokenValid(token)) {
    return <Navigate to="/superadmin/login" replace />;
  }
  return children;
}

